import { makeApi } from "./callApi";

export class CategoryApi {
    static async getDisplayCategories(displayCategoryTypes = []) {
        const response = await makeApi(`/display-category/list`, "POST", {
          type: displayCategoryTypes,
        });
        return response.data;
      }

      static async getDisplayCategoryById(displayCategoryId) {
        const response = await makeApi(`/display-category/${displayCategoryId}`, "GET");
        return response.data;
      }
}
